// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3u-1m","label":"LabeledBox_label__1hO0p"};